// 权限点枚举：取值必须与后端保持一致（DidaOJ-go/foundation/foundation-auth/type.go）。
//
// 这里只定义**标识符**，不定义「角色→权限」的映射。判定所需的有效权限点由后端在
// 登录/刷新时通过 permissions 字段下发（见 stores/user.ts），前端不再自行由角色推算。
//
// 为什么删掉原先的本地推算：它要求前端长期持有一份「角色→权限」映射，而后端改动授权
// （角色权限、用户组绑定、组成员变动）前端无从知晓，必须重新部署前端才生效。
// 那份映射也确实漂移了——前端写着后端根本不存在的 i-manage-bot-game，而游戏编辑接口
// 实际要求 i-manage-problem，于是该入口对 r-admin 之外的合法用户永远不显示。
//
// 新增权限点的顺序：后端 foundation-auth 注册（type.go 常量 + permission.go 的
// RegisterPermission）→ 本枚举 → view-config / tab-config 中引用。
//
// 注意这只是 UI 层的依据：后端每个接口都独立校验，前端权限不可信。
export enum AuthType {
  ManageWeb = "i-manage-web",
  ManageJudge = "i-manage-judge",
  ManageProblem = "i-manage-problem",
  ManageProblemDaily = "i-manage-problem-daily",
  ManageContest = "i-manage-contest",
  ManageCollection = "i-manage-collection",
  ManageDiscuss = "i-manage-discuss",
  ManageBot = "i-manage-bot",
  ManagePermission = "i-manage-permission",
  ManageAI = "i-manage-ai",
}
